import styled, { css } from "styled-components";

export const CarouselWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  height: 440px;

  .react-multi-carousel-list {
    margin: ${({ isMobile }) => (isMobile ? "0" : "0 75px")};
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
  }

  .react-multi-carousel-track {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    position: relative;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    will-change: transform, transition;
  }

  .react-multi-carousel-dot-list {
    position: absolute;
    bottom: 0;
    display: flex;
    left: 0;
    right: 0;
    justify-content: center;
    margin: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }

  .react-multi-carousel-item {
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }

  .react-multi-carousel-item[aria-hidden="true"] {
    a {
      display: none;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .react-multi-carousel-item {
      flex-shrink: 0 !important;
    }

    .react-multi-carousel-track {
      overflow: visible !important;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  justify-content: center;
  user-select: none;
`;

export const Dot = styled.div<{ active?: boolean }>`
  cursor: pointer;
  width: 40px;
  height: 6px;
  margin: 0 10px;
  background: ${({ active }) => (active ? "#262626" : "#fff")};
  -webkit-tap-highlight-color: transparent;
`;

export const ArrowWrapper = css`
  cursor: pointer;
  position: absolute;
  top: 40%;
  z-index: 1;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border-radius: 50%;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: -webkit-focus-ring-color solid;
  }

  @media (max-width: 380px) {
    display: none;
  }
`;

export const ArrowWrapperLeft = styled.div<{ isMobile: boolean }>`
  ${ArrowWrapper}

  left: ${({ isMobile }) => (isMobile ? "10px" : "25px")}; ;
`;

export const ArrowWrapperRight = styled.div<{ isMobile: boolean }>`
  ${ArrowWrapper}

  right: ${({ isMobile }) => (isMobile ? "10px" : "25px")}; ;
`;

export const Arrow = css`
  border: 1px solid #fff;
  border-width: 0 6px 6px 0;
  display: inline-block;
  padding: 10px;
  cursor: pointer;
`;

export const ArrowLeft = styled.div`
  ${Arrow}

  margin-right: -10px;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
`;

export const ArrowRight = styled.div`
  ${Arrow}

  margin-left: -10px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
`;
